"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteReason = void 0;
var DeleteReason;
(function (DeleteReason) {
    DeleteReason["DeletedByPolicy"] = "deletedByPolicy";
    DeleteReason["DeletedByUser"] = "deletedByUser";
})(DeleteReason || (exports.DeleteReason = DeleteReason = {}));
